var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyberArkSaml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 20,
    overflow: "visible",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 126 25",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M36.882 16.3477C35.7456 17.4641 34.2903 17.9825 32.7552 17.9825C28.7679 17.9825 26.9936 15.2313 26.9737 12.3604C26.9537 9.4697 28.8477 6.59888 32.7552 6.59888C34.2305 6.59888 35.6459 7.1571 36.7624 8.25359L35.5861 9.38995C34.8086 8.61244 33.7719 8.25359 32.7552 8.25359C29.9641 8.25359 28.6882 10.307 28.7081 12.3206C28.7281 14.3341 29.9242 16.3078 32.7552 16.3078C33.7719 16.3078 34.9083 15.8892 35.6659 15.1116L36.882 16.3477Z",
    fill: "#173159"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M43.3214 11.6427L46.4513 6.79824H48.5646V6.87799L44.1986 13.2576V17.7632H42.4442V13.2576L38.2177 6.87799V6.79824H40.311L43.3214 11.6427Z",
    fill: "#173159"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M52.6116 16.1284H55.9011C56.878 16.1284 58.2137 15.8094 58.2137 14.6132C58.2137 13.437 56.9179 12.8987 55.9011 12.8987H52.5917V16.1284H52.6116ZM52.6116 11.3437H55.921C57.2368 11.3437 57.8947 10.8254 57.8947 9.9681C57.8947 9.19059 57.2169 8.39314 55.9011 8.39314H52.6116V11.3437ZM55.9011 6.79824C57.9944 6.79824 59.6292 7.75518 59.6292 9.92823C59.6292 10.8453 59.1507 11.6826 58.114 12.1013C59.4298 12.5 59.988 13.7959 59.988 14.6332C59.988 17.0255 58.0742 17.7632 55.921 17.7632H50.8971V6.79824H55.9011Z",
    fill: "#173159"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M70.9928 17.7632H62.8788V6.79824H70.933V8.49282H64.6332V11.4633H70.6938V13.0981H64.6332V16.0287H70.9928V17.7632Z",
    fill: "#173159"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M75.7775 8.39314V12.3804H79.1069C80.5622 12.3804 81.2002 11.4633 81.2002 10.4266C81.2002 9.42982 80.5622 8.41308 79.1069 8.41308H75.7775V8.39314ZM83.4928 17.7632H81.4394L78.11 13.9753H75.7974V17.7632H74.0431V6.77831C75.7576 6.77831 77.4522 6.79824 79.1467 6.79824C81.6786 6.79824 83.0144 8.53269 83.0144 10.3868C83.0144 11.9617 82.197 13.4968 80.0439 13.7959L83.3134 17.4442L83.4928 17.7632Z",
    fill: "#173159"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M90.9689 9.86842L89.5534 13.3573H92.3644L90.9689 9.86842ZM93.4211 15.9689H88.5167L87.799 17.7632H84.5096L89.4338 6.79824H92.5638L97.4681 17.7632H94.1388L93.4211 15.9689Z",
    fill: "#173159"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M102.213 9.27033V11.9019H104.506C105.323 11.9019 105.682 11.2839 105.682 10.626C105.682 9.92823 105.283 9.27033 104.466 9.27033H102.213ZM109.27 17.7632H105.861L103.309 14.2145H102.233V17.7632H99.1228V6.79824H104.466C107.277 6.79824 108.732 8.5925 108.732 10.5662C108.732 11.9218 108.254 13.0582 106.419 13.8756L109.27 17.5638V17.7632Z",
    fill: "#173159"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M121.152 6.97767L116.707 12.1611C118.242 13.8557 120.016 15.8293 121.531 17.5638V17.7432H117.683L114.553 14.0949V17.7432H111.443V6.77831H114.553V10.3868C115.49 9.23046 116.507 7.93461 117.444 6.77831H121.152V6.97767Z",
    fill: "#173159"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "text-[#173159] dark:text-[#329CD7]",
    d: "M123.744 5.44258H123.604V5.90111H123.744C123.983 5.90111 124.063 5.82137 124.063 5.66188C124.043 5.50239 123.943 5.44258 123.744 5.44258ZM124.262 6.69856H124.143C124.123 6.69856 124.103 6.69856 124.083 6.67862C124.043 6.61882 124.023 6.57894 123.983 6.4992C123.884 6.33971 123.824 6.24003 123.744 6.14035C123.724 6.12041 123.704 6.10048 123.664 6.10048H123.604V6.63875C123.604 6.67862 123.565 6.7185 123.545 6.7185H123.465C123.425 6.7185 123.385 6.67862 123.385 6.63875V5.36284C123.385 5.32296 123.425 5.30303 123.465 5.30303H123.824C124.143 5.30303 124.302 5.48245 124.302 5.70175C124.302 5.90111 124.183 6.08054 123.923 6.10048C124.003 6.14035 124.163 6.35965 124.322 6.65869C124.322 6.63875 124.322 6.69856 124.262 6.69856ZM123.804 4.88437C123.226 4.88437 122.747 5.36284 122.747 5.98086C122.747 6.59888 123.206 7.07735 123.804 7.07735C124.382 7.07735 124.86 6.59888 124.86 5.98086C124.86 5.36284 124.382 4.88437 123.804 4.88437ZM123.804 7.25678C123.106 7.25678 122.528 6.69856 122.528 5.98086C122.528 5.24322 123.106 4.70494 123.804 4.70494C124.502 4.70494 125.08 5.26315 125.08 5.98086C125.08 6.7185 124.502 7.25678 123.804 7.25678Z",
    fill: "#173159"
  })), /*#__PURE__*/React.createElement("mask", {
    height: 25,
    id: "mask0_27_64",
    maskUnits: "userSpaceOnUse",
    width: 22,
    x: 0,
    y: 0,
    style: {
      maskType: "alpha"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3716 18.5407L11.1244 24.4617V18.6204L21.3716 12.6994V18.5407ZM5.72169 15.7496L10.7057 18.6204V24.4617L0.657895 18.6802L5.72169 15.7496ZM10.6858 0.558214V6.39952L5.72169 9.27033L0.637959 6.35965L10.6858 0.558214ZM21.1523 6.33971L16.0885 9.27033L11.1045 6.39952V0.558214L21.1523 6.33971ZM5.50239 15.3907L0.438596 18.3214L0.41866 6.7185L5.48246 9.62919V15.3907H5.50239ZM10.6858 12.3804L5.92105 15.1316V9.64912L10.6858 6.89793V12.3804ZM11.1045 6.89793L15.8692 9.64912V15.1515L11.1045 12.3804V6.89793ZM10.9051 18.2416L6.14035 15.5104L10.9051 12.7592L15.6699 15.5104L10.9051 18.2416ZM21.4713 12.1411L16.2879 15.1316V9.64912L21.6707 6.53907V6.18022L11.0048 0H10.7855L0.099681 6.18022L0 6.35965L0.0199362 18.6802L0.119617 18.8596L10.8054 25H11.0247L21.6906 18.8397L21.7903 18.6603V12.3206L21.4713 12.1411Z",
    fill: "#FFFFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7903 0H0V25.0199H21.7903V0Z",
    fill: "url(\"#paint0_linear_27_64\")"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_27_64",
    x1: 10.9046,
    x2: 10.9046,
    y1: -1.44589,
    y2: 27.1424
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_27_64",
    x1: 10.9046,
    x2: 10.9046,
    y1: -1.44589,
    y2: 27.1424
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberArkSaml);
export default __webpack_public_path__ + "static/media/CyberArkSAML.a91fe7217ff4354c6d216032801d6472.svg";
export { ForwardRef as ReactComponent };